import type { StoreActionApi } from 'react-sweet-state';
import { INITIAL_UI_STATE } from '../../../common/constants/state';
import type { UIState } from '../../../common/types';
import {
	setRequestAuthenticationToken,
	resetAccessTokenModalState,
	setAccessTokenModalState,
} from './access-token-modal';

import {
	resetCloseModalImportState,
	setCancelImportModalState,
	setIsCancelImportModalOpen,
} from './cancel-import-modal';

export const setUIState =
	(newState: Partial<UIState>) =>
	({ setState }: StoreActionApi<UIState>) => {
		setState(newState);
	};

export const resetUIState =
	() =>
	({ setState }: StoreActionApi<UIState>) => {
		setState(INITIAL_UI_STATE);
	};

export const actions = {
	setUIState,
	resetUIState,
	setIsCancelImportModalOpen,
	resetCloseModalImportState,
	setCancelImportModalState,
	setAccessTokenModalState,
	resetAccessTokenModalState,
	setRequestAuthenticationToken,
};

export type Actions = typeof actions;
